<div id="stickerwidget" class="stickerwidget" #divcointainer>
  <div class="widget">
    <div *ngIf="isToolbarVisible" class="widget-toolbar">
      <button mat-raised-button class="widget-toolbar-btn resetButton" (click)="reset($event)">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>

    <h3 class="widget-title" [translate]="'widgets.stickers.name'">Stickers</h3>
    <div *ngIf="isSmallStickerWidget" class="smallStickerPreview">

      <span class="draggable-sticker draggable-attachable-element sticker-icon"
                *ngFor="let sticker of templateStickers"
                [attr.data-stickerId]="sticker.id">

        <mat-icon *ngIf="sticker.iconName"
                  [style.color]="sticker.iconColor"
                  [attr.data-stickerId]="sticker.id">{{sticker.iconName}}
        </mat-icon>

        <img *ngIf="sticker.imageData"
             [src]="sticker.imageData" />
      </span>
    </div>

    <div *ngIf="!isSmallStickerWidget" class="content">
      <mat-table #table [dataSource]="templateStickers" class="sticker-table">
        <!-- Icon Column -->
        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef [translate]="'widgets.stickers.icon'"> Icon </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="draggable-sticker draggable-attachable-element sticker-icon"
                  [attr.data-stickerId]="element.id">

              <mat-icon *ngIf="element.iconName"
                        [style.color]="element.iconColor"
                        [attr.data-stickerId]="element.id">{{element.iconName}}
              </mat-icon>

              <img *ngIf="element.imageData"
                   [src]="element.imageData" />
            </span>
          </mat-cell>
        </ng-container>

        <!-- Comment Column -->
        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef [translate]="'widgets.stickers.comment'"> Comment </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-form-field floatLabel="never">
              <input matInput placeholder="{{'widgets.stickers.comment' | translate}}" [value]="element.comment" [(ngModel)]="element.comment" (change)="updateSticker(element)" >
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <!-- <button mat-stroked-button (click)="changeIcon(element)">
              <mat-icon>settings</mat-icon><mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
            </button> -->
            <span *ngIf="element.iconName; else disabledButton"
                  [(colorPicker)]="element.iconColor"
                  (colorPickerSelect)="this.updateSticker(element)"
                  [cpPresetColors]="['#f5cf09','#f43248', '#6bc01c', '#0e96e7']"
                  [cpAddColorButton]="true"
                  [cpPosition]="'bottom'"
                  [cpAlphaChannel]="'disabled'"
                  [cpDialogDisplay]="'popup'"
                  [cpUseRootViewContainer]="'true'"
                  [cpRemoveColorButtonClass]="'removePresetColorButton'"
                  [style.color]="element.iconColor">
              <button mat-stroked-button>
                <mat-icon>color_lens</mat-icon><mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
              </button>
            </span>
            <ng-template #disabledButton>
              <div style="min-width: 80px!important;"></div>
            </ng-template>

            <button mat-stroked-button (click)="removeSticker(element)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <!-- add sticker -->
      <div class="add-button">
        <button mat-stroked-button color="success" (click)="addSticker()"><mat-icon>add</mat-icon></button>
      </div>
    </div>

  </div>
</div>
